/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useCustomerConfigQuery } from "~/generated/graphql";

export function useFeature(name: string): boolean {
  const { data } = useCustomerConfigQuery();
  const customerConfig = data?.customerConfig;

  if (["allowExperimental", "riEnabled"].includes(name)) {
    return Boolean(
      name === "allowExperimental"
        ? customerConfig?.allowExperimental
        : customerConfig?.riEnabled
    );
  }

  const enabledFeatures = customerConfig?.enabledFeatures || [];
  return enabledFeatures.includes(name);
}
